import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

const CONNECT_KEY = '7jvp4j/capusta';

const options = {
  network: {
    requestSanitizer: request => {
      // const url = request.url.toLowerCase();

      if (request.headers.Authorization) {
        request.headers.Authorization = '';
      }

      return request;
    },
    responseSanitizer: response => {
      if (response.headers.Authorization) {
        // removes all response data
        return null;
      }

      // scrubs response body
      response.body = null;

      return response;
    },
  },
};

function init() {
  try {
    LogRocket.init(CONNECT_KEY, options);
  } catch (e) {
    console.error(e);
  }
}

function logger(error) {
  LogRocket.captureMessage(error);
}

function identify(key, data) {
  LogRocket.identify(key, data);
}

export const logrocketPlugin = createPlugin(LogRocket);

export default {
  init,
  logger,
  identify,
};
